// Tunable constants for the ad layer + quiz economy.
// Mirrors the original QuizzyLoot harness values.

export const RETRY_LIMIT = 15; // max recursive re-fires on notReady/noAdPreloaded
export const RETRY_DELAY_MS = 600; // backoff between retries
export const DEBOUNCE_MS = 1500; // ignore repeat ad triggers within this window

export const COIN_PER_Q = 100; // coins awarded for a correct answer
export const INTERSTITIAL_EVERY = 5; // fire an interstitial every N question advances
export const HINT_COIN_COST = 50; // coins to buy a hint (or watch a rewarded ad free)
export const QUESTION_TIME_SEC = 15; // seconds allowed per question before it times out
